import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@material-ui/core'
import EmptySection from '../../atoms/EmptySection'
import { RSSFeedContext } from './RSSFeedContext'
import { useRSSFeed } from './hooks/useRSSFeed'

function RSSFeed ({
  url,
  take,
  skip,
  children,
  emptyMessage,
  errorMessage,
  className,
  style,
  ...rest
}) {
  const {
    data,
    isLoading,
    isError,
    error,
    isFetching,
    refetch
  } = useRSSFeed({
    url,
    take,
    skip
  })

  const feed = data?.feed || {}
  const items = data?.items || []
  const total = data?.total || 0

  const contextValue = {
    feed,
    items,
    total,
    isLoading,
    isError,
    error,
    isFetching,
    refetch
  }

  if (isLoading) {
    return (
      <div className='flex w-full p-4 items-center justify-center' style={{ minHeight: '200px' }}>
        <CircularProgress />
      </div>
    )
  }

  if (isError) {
    return (
      <div className='flex w-full p-4 items-center justify-center' style={{ minHeight: '200px' }}>
        <EmptySection
          title={errorMessage || 'Failed to load RSS feed'}
          description={error?.message || 'An error occurred while fetching the feed'}
        />
      </div>
    )
  }

  if (!items || items.length === 0) {
    return (
      <div className='flex w-full p-4 items-center justify-center' style={{ minHeight: '200px' }}>
        <EmptySection
          title={emptyMessage || 'No feed items found'}
          description=''
          emptyDescription
        />
      </div>
    )
  }

  return (
    <RSSFeedContext.Provider value={contextValue}>
      <div className={className} style={style} {...rest}>
        {children}
      </div>
    </RSSFeedContext.Provider>
  )
}

RSSFeed.propTypes = {
  url: PropTypes.string.isRequired,
  take: PropTypes.number,
  skip: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func
  ]).isRequired,
  emptyMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default RSSFeed
